import { useVectorCapitalSimulator } from './VectorCapitalSimulatorContext';

/** Provider-level modals/overlays shared across VC pages and dashboard widgets. */
export default function VectorCapitalGlobalOverlays() {
  const sim = useVectorCapitalSimulator();
  if (!sim.basketModalOpen || !sim.renderBasketModal) return null;
  return sim.renderBasketModal();
}
